import { RequestedFeature } from "@vixi/types";
import { api } from "@/apiInstance";
import { debounceAsync } from "@vixi/utils";
import { AxiosResponse } from "axios";

const voteCache: Record<string, (isUpvote: boolean) => Promise<AxiosResponse>> = {};

export async function debouncedVote(featureId: RequestedFeature["id"], isUpvote: boolean) {
  if (voteCache[featureId]) {
    return voteCache[featureId](isUpvote);
  }

  voteCache[featureId] = debounceAsync(async (isUpvote: boolean) => {
    return api.post(api.endpoints[isUpvote ? "upvoteFeature" : "downvoteFeature"](featureId));
  }, 750);

  return voteCache[featureId](isUpvote);
}
